import { svc_search, svc_fetchOne } from "@/services";
import { message } from "antd";
import "lodash";
import logger from "@/utils/logger";
import { convertISODateTimeToString } from "@/utils/convertTime";

const endpointBasePrefix = "transactions";


const Model = {
	namespace: "m_Transactions",
	state: {
		transactions: [],
		selectedTransaction: {}
	},
	reducers: {
		handleFetchAll(state, { payload: { transactions } }) {
			logger(`** Transactions reducers response ${JSON.stringify(transactions)}`, 5);
			return { ...state, transactions };
		},
		handleFetchOne(state, { payload: { selectedTransaction } }) {
			logger(`** Transactions reducers response ${JSON.stringify(selectedTransaction)}`, 5);
			return { ...state, selectedTransaction };
		},
	},
	effects: {
		*fetchAll({ payload }, { call, put }) {
			let transactions = yield call(svc_search, endpointBasePrefix, payload);
			_.forEach(transactions, function (row) {
				row.key = row.id;
			});
			yield put({
				type: "handleFetchAll",
				payload: { transactions },
			});
		},
		*fetchOne({ transaction_id }, { call, put }) {
			let selectedTransaction = yield call(svc_fetchOne, endpointBasePrefix, transaction_id);
			selectedTransaction.key = selectedTransaction.id;
			selectedTransaction = convertISODateTimeToString(selectedTransaction, ["accounting_date", "transaction_timestamp", "seated_time"]);

			// console.log("*********************** fetchOne selectedTransaction: ", selectedTransaction)
			yield put({
				type: "handleFetchOne",
				payload: { selectedTransaction },
			});
		}
	},
	subscriptions: {
		setup({ dispatch, history }) {
			return history.listen(({ pathname, query }) => {
				if (pathname === "/salesdata/daily_sales") {
					dispatch({ type: "fetch", payload: query });
				}
			});
		},
	},
};

export default Model;
